import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API } from '../../utils/api';
import './AdminLogin.css';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const [loading, setLoading]   = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Invalid credentials.');
      login({ username: data.username, token: data.token });
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='al-shell'>
      <div className='al-card'>
        <div className='al-brand'>
          <span className='al-dot'></span>
          <span>RastegHub</span>
          <span className='al-label'>Admin</span>
        </div>

        <h1 className='al-title'>Sign in</h1>
        <p className='al-sub'>Access the RastegHub admin dashboard</p>

        <form className='al-form' onSubmit={handleSubmit}>
          <div className='al-field'>
            <label>Username</label>
            <input
              type='text'
              placeholder='admin'
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete='username'
              required
            />
          </div>
          <div className='al-field'>
            <label>Password</label>
            <input
              type='password'
              placeholder='••••••••'
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete='current-password'
              required
            />
          </div>

          {error && <p className='al-error'> {error}</p>}

          <button className='al-btn' type='submit' disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

        <a href='/' className='al-back'>← Back to site</a>
      </div>
    </div>
  );
}